import { type MCPServerInfo } from '../../types';

const AvalaraTaxContentServer: MCPServerInfo = {
  serverId: 'AVALARA_TAX_CONTENT',
  name: 'Avalara Tax Content',
  slug: 'avalara-tax-content',
  description:
    "Avalara's official remote MCP server for Tax Content — query Avalara's tax rate, rule, and product taxability content directly from your AI assistant.",
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.avalara.com/atc'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default AvalaraTaxContentServer;
